import Vue from 'vue'

Vue.directive('cursor-anchor', {
  inserted (el, binding) {
    const value = binding.value || {}
    el.dataset.cursorAnchor = value.mode || ''
    el.dataset.cursorAnchorIcon = value.icon || ''
  },
  update (el, binding) {
    const value = binding.value || {}
    el.dataset.cursorAnchor = value.mode || ''
    el.dataset.cursorAnchorIcon = value.icon || ''
  },
  unbind (el) {
    delete el.dataset.cursorAnchor
  }
})
